import AvatarChangeStore from "../stores/AvatarChangeStore";
import React from "react";

const storesContext = React.createContext({
    avatarChangeStore: new AvatarChangeStore()
})

export default storesContext